import { render, staticRenderFns } from "./EventOrganization.vue?vue&type=template&id=74c46c5b&lang=pug"
import script from "./EventOrganization.vue?vue&type=script&lang=js"
export * from "./EventOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports